export default {
  navigation() {
    const className = "c-menuNavigation--expanded",
      menu = $(".c-menuNavigation"),
      btnText = $(".c-menuNavigation__toggle span");

    var expanded = false;

    /**
     * Open main navigation menu
     */
    $(".c-menuNavigation__toggle").click((e) => {
      e.preventDefault();

      // Toggle menu expansion
      if (!expanded) {
        // Expand menu
        expand();
      } else {
        // Collapse menu
        collapse();
      }
    });

    function expand() {
      let menuHeight =
        $(window).height() - $(".o-header__content").outerHeight();

      btnText.html("Mindre ");

      menu.addClass(className);
      menu.animate(
        {
          "max-height": `${menuHeight}px`,
        },
        500,
        () => {
          menu.css("overflow-y", "auto");
        }
      );
      expanded = true;
    }

    function collapse() {
      let menuHeight = $(menu.find("ul > li > a")[0]).outerHeight(true);

      btnText.html("MER ");

      menu.removeClass(className);
      menu.animate({
        "max-height": `${menuHeight}px`,
      });

      menu.css("overflow-y", "hidden");
      expanded = false;
    }
  },

  districts() {
    const container = $(".c-menuGlobal__wrapper, .c-menuCTA"),
      className = `${container.attr("class")}--expanded`,
      menu = $(".c-menuDistricts"),
      toggleBtns = $(".c-menuGlobal__toggle, .c-menuCTA__toggle");

    toggleBtns.click((e) => {
      e.preventDefault();

      if (container.hasClass(className)) {
        container.removeClass(className);
        menu.animate(
          {
            "max-height": 0,
          },
          {
            complete: () => {
              menu.css("display", "none");
            },
          }
        );
      } else {
        container.addClass(className);
        menu.animate(
          {
            "max-height": "1000px",
          },
          {
            start: () => {
              menu.css("display", "block");
            },
          }
        );
      }
    });
  },

  mobile() {
    var opened = false;
    var expanded = false;

    /**
     * District picker
     */
    $(".c-mobileHeader__districtToggle").change((e) => {
      location.href = e.target.value;
    });

    /**
     * Open mobile navigation
     */
    $(".c-mobileHeader__navbar .toggle").click(() => {
      if (opened) {
        $("html, body").css("overflow", "visible");
        $(".o-mobileHeader .hamburger").removeClass("is-active");
        $(".c-menuMobile").css("display", "none");
        $(".c-mobileHeader__districtToggle").css("display", "block");
        $(".c-mobileHeader__navbar .toggle label").html("Meny");
        opened = false;
      } else {
        $("html, body").css("overflow", "hidden");
        $(".o-mobileHeader .hamburger").addClass("is-active");
        $(".c-menuMobile").css("display", "block");
        $(".c-mobileHeader__districtToggle").css("display", "none");
        $(".c-mobileHeader__navbar .toggle label").html("Stäng");
        opened = true;
      }
    });

    /**
     * Expand sub menu
     */
    $(".c-menuMobile__item .icon-plus-1").on("click", (e) => {
      const menu = $(e.target).closest("li").find("ul");
      const indicator = $(e.target);

      if (expanded) {
        menu.removeClass("toggle");
        expanded = false;
        indicator.attr("class", "icon-plus-1");
      } else {
        menu.addClass("toggle");
        expanded = true;
        indicator.attr("class", "icon-minus-1");
      }
    });
  },

  sidebar() {
    if ($("li").hasClass("current_page_parent")) {
      $(".current_page_ancestor, .current_page_item")
        .children("a")
        .children("i")
        .addClass("open");
    } else {
      $(".current_page_item").children("a").children("i").addClass("open");
    }

    $(".o-sidebar .icon-plus-1").on("click", (e) => {
      const icon = $(e.currentTarget);
      const sideMenu = $(".o-sidebar");
      e.preventDefault();

      if (sideMenu.hasClass("open")) {
        sideMenu.removeClass("open");
        icon.attr("class", "icon-plus-1");
      } else {
        sideMenu.addClass("open");
        icon.attr("class", "icon-minus-1");
      }
      console.log(sideMenu);
    });
  },
};
